<template>
    <div class="service-container">
        <div class="container">
            <div class="banner"></div>
            <div class="tips">
                借款申请时使用优惠券，对应借款在提前还清时，后续期数仅需偿还本金，息费全免。
            </div>
            <Level :list="content.countList" />
            <Coupons
                :couponsList="content.awardList"
                :level="content.level"
                :percent="percent"
                @gocoupons="gocoupons()"
                @awardCoupon="receivePaidOffAheadCoupon"
                v-if="!status"
            />
            <Record :recordList="content.receivedList" v-if="!status" />

            <div class="btn" v-if="status" @click="skipOuter()">{{ statusDesc().desc }}</div>
            <div class="btn-bottom-txt" v-if="status">升至V1可领取</div>
        </div>
        <Dialog
            :show="showDialog"
            title="前往首页申请借款，成交后即可激活成长权益"
            lefttxt="再看看"
            righttxt="去首页"
            @giveupBtn="giveupBtn"
            @continueBtn="continueBtn"
        />
        <Dialog2
            :show="showResDialog"
            title="领取成功，已发放至优惠券中心"
            lefttxt="暂不使用"
            righttxt="立即使用"
            @giveupBtn="pauseUse"
            @continueBtn="useImm"
        />
    </div>
</template>

<script>
import homemixin from '@common/js/mixin';
export default {
    name: 'interestfree',
    components: {
        Level: () => import('../../componets/interestfree/level'),
        Coupons: () => import('../../componets/interestfree/coupons'),
        Record: () => import('../../componets/interestfree/record'),
        Dialog: () => import('../../componets/birthday/homeDialog'),
        Dialog2: () => import('../../componets/birthday/homeDialog')
    },
    mixins: [homemixin],
    data() {
        return {
            showDialog: false,
            showResDialog: false,
            status: true, // 判断新客老客
            level: 0,
            btnTxt: '去激活',
            percent: {},
            content: null,
            resMsg: '',

            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goBacktoHome
                    }
                ],
                titleView: {
                    text: '提前还免息费',
                    color: '#000000'
                },
                rightView: []
            }
        };
    },
    created() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
        this.getPaidOffAheadPageInfo();
    },
    methods: {
        goBacktoHome() {
            // this.$router.push('/');
            window.PPDWebUI.CommonService.close({});
        },
        giveupBtn() {
            this.showDialog = false;
        },
        continueBtn() {
            this.goHome();
        },
        pauseUse() {
            this.showResDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_提前还免息费领取弹窗',
                page: 'super-提前还免息费领取弹窗',
                param1: `${this.content.level}`,
                param2: `${this.content.receivedList ? this.content.receivedList.length : 0}`,
                param3: `暂不使用`
            });
        },
        gocoupons() {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_提前还免息费',
                page: 'super-提前还免息费',
                param1: `${this.content.level}`,
                param2: `${this.content.receivedList ? this.content.receivedList.length : 0}`,
                param3: `查看优惠券`
            });
            this.openLink(this.$couponsLink);
        },
        useImm() {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_提前还免息费领取弹窗',
                page: 'super-提前还免息费领取弹窗',
                param1: `${this.content.level}`,
                param2: `${this.content.receivedList ? this.content.receivedList.length : 0}`,
                param3: `立即使用`
            });
            this.showResDialog = false;
            this.openLink(this.$couponsLink);
        },
        statusDesc() {
            if (this.content.level == 'NEW') {
                return {
                    desc: '去激活',
                    class: 1
                };
            } else if (this.content.level == 'V0') {
                return {
                    desc: '去升级',
                    class: 1
                };
            }
        },
        skipOuter() {
            if (this.content.level == 'V0') {
                localStorage.setItem('updata', 'true');
                // this.$router.replace({
                //     path: '/'
                // });
                this.goClose();
            } else if (this.content.level == 'NEW') {
                this.showDialog = true;
            }
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_提前还免息费',
                page: 'super-提前还免息费',
                param1: `${this.content.level}`,
                param2: `${this.content.receivedList ? this.content.receivedList.length : 0}`,
                param3: `${this.statusDesc().desc}`
            });
        },

        async receivePaidOffAheadCoupon() {
            if (this.receivePaidAciton) {
                return;
            }
            this.receivePaidAciton = true;
            const { Result, ResultMessage } = await this.$http.receivePaidOffAheadCoupon();
            if (Result === 200) {
                this.showResDialog = true;
                await this.getPaidOffAheadPageInfo();
                this.resMsg = '领取成功';
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_imp',
                    tgt_name: 'h5_ACT_提前还免息费领取弹窗',
                    page: 'super-提前还免息费领取弹窗',
                    param1: `${this.content.level}`,
                    param2: `${this.content.receivedList ? this.content.receivedList.length : 0}`
                });
            } else if (Result === 40708) {
                this.$toast({
                    message: '领取失败，请前往权益首页查看您当前权益。',
                    duration: 2000
                });
                this.resMsg = `失败 ${ResultMessage}`;
            } else {
                this.$toast({
                    message: `${ResultMessage}`,
                    duration: 2000
                });
                this.resMsg = `失败 ${ResultMessage}`;
            }
            this.receivePaidAciton = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_提前还免息费',
                page: 'super-提前还免息费',
                param1: `${this.content.level}`,
                param2: `${this.content.receivedList ? this.content.receivedList.length : 0}`,
                param3: `领取`,
                param5: `${this.resMsg}`
            });
        },
        async getPaidOffAheadPageInfo() {
            const { Result, Content } = await this.$http.getPaidOffAheadPageInfo();
            if (Result === 200) {
                this.content = Content;

                let list = Content.countList;
                let currentLevelCount = 0;
                for (let i = 0; i < list.length; i++) {
                    if (Content.level === list[i].level) {
                        currentLevelCount = list[i].count;
                        break;
                    }
                }
                this.percent = {
                    a: Content.receivedList ? Content.receivedList.length : 0,
                    b: currentLevelCount
                };
                if (Content.level == 'NEW' || Content.level == 'V0') {
                    this.status = true;
                } else {
                    this.status = false;
                }
            }
            this.POINT('h5_element_imp', {
                tgt_event_id: 'h5_ACT_imp',
                tgt_name: 'h5_ACT_提前还免息费',
                page: 'super-提前还免息费',
                param1: `${this.content.level}`,
                param2: `${this.content.receivedList ? this.content.receivedList.length : 0}`
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';

.service-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    overflow-y: auto;

    .container {
        width: 100%;

        .banner {
            .backgroundImage(375px, 140px, '~@assets/img/free_banner.png');
        }

        .tips {
            .f-14();
            color: rgba(41, 39, 56, 1);
            line-height: 20px;
            margin: auto;
            width: 348px;
            padding-left: 11px;
            margin-top: 30px;
        }

        .btn {
            .backgroundImage(212px, 40px, '~@assets/img/birthday_btn.png');
            margin: auto;
            margin-top: 50px;
            color: #ece0cf;
            .f-16-bold();
            text-align: center;
            line-height: 40px;
        }

        .btn-bottom-txt {
            font-size: 12px;
            font-family: FZLTHDemiBold--GB1-4-YS, FZLTHDemiBold--GB1-4;
            font-weight: normal;
            color: rgba(164, 167, 179, 1);
            line-height: 12px;
            margin: auto;
            margin-top: 18px;
            text-align: center;
        }
    }
}
</style>
